import { handle } from 'redux-pack';
import { Action } from '../../../types/actions';
import {
	GET_PASSCODE_LIST_MEMBERS,
	GET_MORE_MEMBERS,
	SEARCH_MEMBERS,
	ADD_SELECTED_MEMBER,
	REMOVE_SELECTED_MEMBER,
	SEARCH_MEMBER_COUNT,
	REMOVE_ALL_MEMBERS,
} from '../../actions/admin/passcode-list-members';

export interface PasscodeListMembersState {
	members: any[];
	selectedMembers: any[];
	member_count: number;
	loadingMembers: boolean;
}

const initialState: PasscodeListMembersState = {
	members: [],
	selectedMembers: [],
	member_count: 0,
	loadingMembers: false,
};

export default function PasscodeListMembersReducer(
	state: PasscodeListMembersState = initialState,
	action: Action
): PasscodeListMembersState {
	switch (action.type) {
		case GET_PASSCODE_LIST_MEMBERS: {
			return handle(state, action, {
				start: state => ({ ...state, loadingMembers: true }),
				success: (state) => ({ ...state, members: action.payload }),
				finish: state => ({ ...state, loadingMembers: false }),
			});
		}
		case GET_MORE_MEMBERS: {
			return handle(state, action, {
				start: state => ({ ...state, loadingMembers: true }),
				success: (state) => ({
					...state,
					members: [...state.members.concat(action.payload)],
				}),
				finish: state => ({ ...state, loadingMembers: false }),
			});
		}
		case SEARCH_MEMBERS: {
			return handle(state, action, {
				start: state => ({ ...state, loadingMembers: true }),
				success: (state) => ({ ...state, members: action.payload }),
				finish: state => ({ ...state, loadingMembers: false }),
			});
		}
		case SEARCH_MEMBER_COUNT: {
			return handle(state, action, {
				success: (state) => ({
					...state,
					member_count: Number(action.payload[0]?.member_count),
				}),
			});
		}
		case ADD_SELECTED_MEMBER: {
			return {
				...state,
				selectedMembers: [...state.selectedMembers, action.payload],
			};
		}

		case REMOVE_SELECTED_MEMBER: {
			return {
				...state,
				selectedMembers: state.selectedMembers.filter(
					(member) =>
						member.passcode_list_member !==
						action.payload.passcode_list_member
				),
			};
		}

		case REMOVE_ALL_MEMBERS: {
			return {
				...state,
				selectedMembers: [],
			};
		}

		default:
			return state;
	}
}
